import { UploadService, UploadPacketReworkService } from 'services';
import { Toast } from 'shared/helpers';

/**
 * Fetches the signed URL and updates the blob state with the URL.
 * @param fileNameList - array of fileName.
 * @param clientId - the client id.
 * @param binNumber - bin number of client.
 * @returns A promise that resolves to an updated BlobItem with the URL.
 */
export const SignedReplaceDocTester = async (
    fileNameList: any[],
    clientId: string,
    binNumber: any,
    packetId: string
): Promise<BlobItem | any> => {
    try {
        const response = await UploadService.signedUrl({
            fileNameList,
            clientId,
            binNumber,
            packetId,
            type: 'document',
        });
        const uploadList: Array<any> = response.data.data.uploadList.map(
            (item: any) => ({
                url: item.sasUrl,
                fileName: item.placeholder,
                packetId: item.packetId,
                uploadId: response.data.data.uploadId,
                clientId,
            })
        );

        return {
            url: uploadList[0].url,
            fileName: uploadList[0].fileName,
        };
    } catch (error: any) {
        const errorMessage = `failed upload: ${error.response.data.msg}`;

        if (error.response.data.msg.includes('Invalid packet name format')) {
            Toast.showToast(Toast.showErrorMessage, errorMessage, {
                autoClose: 120000,
            });
        } else {
            Toast.showErrorMessage(errorMessage);
        }
        console.log('error message', errorMessage);
        return null;
    }
};

/**
 * Fetches the signed URL and updates the blob state with the URL.
 * @param fileNameList - array of fileName.
 * @param clientId - the client id.
 * @param binNumber - bin number of client.
 * @returns A promise that resolves to an updated BlobItem with the URL.
 */
export const SignedUrlTester = async (
    fileNameList: any[],
    clientId: string,
    binNumber: any
): Promise<UploadSignFormat | any> => {
    try {
        const response = await UploadService.signedUrl({
            fileNameList,
            clientId,
            binNumber,
            type: 'packet',
        });
        const uploadList: Array<UploadSignFormat> =
            response.data.data.uploadList.map((item: any) => ({
                url: item.sasUrl,
                fileName: item.placeholder,
                packetId: item.packetId,
                file: item.file,
                uploadId: response.data.data.uploadId,
                clientId,
            }));

        return {
            uploadList,
        };
    } catch (error: any) {
        if (error && error.response && error.response.data) {
            const errorMessage = `failed upload: ${error.response.data.msg}`;

            if (
                error.response.data.msg.includes('Invalid packet name format')
            ) {
                Toast.showToast(Toast.showErrorMessage, errorMessage, {
                    autoClose: 120000,
                });
            } else {
                Toast.showErrorMessage(errorMessage);
            }
            console.log('error message', errorMessage);
        }

        throw error;
    }
};

/**
 * Fetches the signed rework URL and updates the blob state with the URL.
 * @param name - The name of the blob.
 * @param token - The authentication token.
 * @returns A promise that resolves to an updated BlobItem with the URL.
 */
export const SignedReworkUrlTester = async (
    name: string,
    packetId: string,
    token: string
): Promise<BlobItem | any> => {
    try {
        const response = await UploadPacketReworkService.signedUrl({
            fileName: name,
            packetId,
            token,
        });
        return {
            name,
            url: response.data.data.url,
            blobdata: new Uint8Array(0),
            fileName: response.data.data.fileName,
        };
    } catch (error: any) {
        if (error.response && error.response.data) {
            const errorMessage = `failed upload ${name}: ${error.response.data.msg}`;

            if (
                error.response.data.msg.includes('Invalid packet name format')
            ) {
                Toast.showToast(Toast.showErrorMessage, errorMessage, {
                    autoClose: 120000,
                });
            } else {
                Toast.showErrorMessage(errorMessage);
            }
            console.log('error message', errorMessage);
            return null;
        }
        throw error;
    }
};
